import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BookmarksSubjectDialogComponent } from '../bookmarks-subject-dialog/bookmarks-subject-dialog.component';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-bookmarks-list',
  templateUrl: './bookmarks-list.component.html',
  styleUrls: ['./bookmarks-list.component.css']
})
export class BookmarksListComponent implements OnInit {
  allBookMarksList:any;
  selectedFilterValues:any =[];
  dummyLikedVideoData =
    [
      {
        "cardType": 'Topic_summary',
        "subjectId": 2,
        "topicId": 1515,
        "topicName": "Equilibrium of system of charges system of charges",
        "subtopicsCount": 1,
        "publishedFlashcardCount": 3,
        "publishedVideoCount": 5,
        "flashcardTaggedQuestionsCount": 3,
        "subjects": [
          {
            "subjectId": 2,
            "subject": "Chemistry"
          }
        ]
      },
      {
        "cardType":'videos',
        "mappingId": 143,
        "videoId": 987,
        "title": "Work energy theorem and its applications.mp4",
        "thumbnailURL": "https://s3-alpha-sig.figma.com/img/054d/ff60/c4b1f9e3041360ef7c55eeff7ce653a0?Expires=1683504000&Signature=g~gJtQYzhy-rwmMUt0SMK-C3D55aYzkuhz-OROOVE82LQ5oa4EdH9Prtv9gCfOu9o3Y5geDm6hUmaxNdWeEHwTSOkAafMMWg41q0CLWlNj1gE3~Rh8NVvQmCsfyXcHlIfBSDEvd37fS~q2Qst65VFRwU9qKoDBGQ~ftTQT0S2in4Pc1WUgnv6Qe3KqsSgAN1H2UUOT56KW26n37tvMYUjxaE0MASkXKpfMSAZ0~CqomASQnBWgOLK9fF1KLnOPxUco1M7yUsSqU0yGJPlrxvpaiSmj8Ty-fYZGY6NkfwqqBnBSAXGUy2E4EoKdP95VjrmKfPYFwfb4ex6NKVj6-GlA__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4",
        "videoURL": "",
        "videoTypeId": 1,
        "videoType": "Conceptual",
        "orderId": 0,
        "duration": "147",
        "description": "",
        "subtopics": [
          {
            "subtopicId": 2186,
            "subtopicName": "Work energy theorem and its applications"
          }
        ],
        "subjects": [
          {
            "subjectId": 1,
            "subject": "Physics"
          }
        ]
      },
      {
        "cardType": 'questions',
        "mappingId": 143,
        "videoId": 987,
        "title": "The state of heart when it is not pumping blood effect...",
        "videoURL": "",
        "videoTypeId": 1,
        "videoType": "Conceptual",
        "orderId": 0,
        "duration": "147",
        "description": "",
        "subtopics": [
          {
            "subtopicId": 2186,
            "subtopicName": "Work energy theorem and its applications"
          }
        ],
        "subjects": [
          {
            "subjectId": 3,
            "subject": "Mathematics"
          }
        ]
      },
      {
        "cardType": 'Topic_summary',
        "subjectId": 2,
        "topicId": 1515,
        "topicName": "Equilibrium of system of charges system of charges",
        "subtopicsCount": 1,
        "publishedFlashcardCount": 3,
        "publishedVideoCount": 5,
        "flashcardTaggedQuestionsCount": 3,
        "subjects": [
          {
            "subjectId": 3,
            "subject": "Mathematics"
          }
        ]
      },
      {
        "cardType": 'memory_cards',
        "videoId": 987,
        "title": "The state of heart when it is not pumping blood effect...",
        "videoURL": "",
        "videoTypeId": 1,
        "videoType": "Conceptual",
        "orderId": 0,
        "duration": "147",
        "description": "",
        "subtopics": [
          {
            "subtopicId": 2186,
            "subtopicName": "Work energy theorem and its applications"
          }
        ],
        "subjects": [
          {
            "subjectId": 1,
            "subject": "Physics"
          }
        ]
      },
      {
        "cardType": 'Topic_summary',
        "subjectId": 2,
        "topicId": 1515,
        "topicName": "Equilibrium of system of charges system of charges",
        "subtopicsCount": 1,
        "publishedFlashcardCount": 3,
        "publishedVideoCount": 5,
        "flashcardTaggedQuestionsCount": 3,
        "subjects": [
          {
            "subjectId": 2,
            "subject": "Chemistry"
          }
        ]
      },
      {
        "cardType": 'memory_cards',
        "videoId": 987,
        "title": "The state of heart when it is not pumping blood effect...",
        "videoURL": "",
        "videoTypeId": 1,
        "videoType": "Conceptual",
        "orderId": 0,
        "duration": "147",
        "description": "",
        "subtopics": [
          {
            "subtopicId": 2186,
            "subtopicName": "Work energy theorem and its applications"
          }
        ],
        "subjects": [
          {
            "subjectId": 2,
            "subject": "Chemistry"
          }
        ]
      },
      {
        "cardType": 'videos',
        "mappingId": 143,
        "videoId": 987,
        "title": "Work energy theorem and its applications.mp4",
        "thumbnailURL": "https://s3-alpha-sig.figma.com/img/054d/ff60/c4b1f9e3041360ef7c55eeff7ce653a0?Expires=1683504000&Signature=g~gJtQYzhy-rwmMUt0SMK-C3D55aYzkuhz-OROOVE82LQ5oa4EdH9Prtv9gCfOu9o3Y5geDm6hUmaxNdWeEHwTSOkAafMMWg41q0CLWlNj1gE3~Rh8NVvQmCsfyXcHlIfBSDEvd37fS~q2Qst65VFRwU9qKoDBGQ~ftTQT0S2in4Pc1WUgnv6Qe3KqsSgAN1H2UUOT56KW26n37tvMYUjxaE0MASkXKpfMSAZ0~CqomASQnBWgOLK9fF1KLnOPxUco1M7yUsSqU0yGJPlrxvpaiSmj8Ty-fYZGY6NkfwqqBnBSAXGUy2E4EoKdP95VjrmKfPYFwfb4ex6NKVj6-GlA__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4",
        "videoURL": "",
        "videoTypeId": 1,
        "videoType": "Conceptual",
        "orderId": 0,
        "duration": "147",
        "description": "",
        "subtopics": [
          {
            "subtopicId": 2186,
            "subtopicName": "Work energy theorem and its applications"
          }
        ],
        "subjects": [
          {
            "subjectId": 1,
            "subject": "Physics"
          }
        ]
      },
      {
        "cardType": 'memory_cards',
        "videoId": 987,
        "title": "The",
        "videoURL": "",
        "videoTypeId": 1,
        "videoType": "Conceptual",
        "orderId": 0,
        "duration": "147",
        "description": "",
        "subtopics": [
          {
            "subtopicId": 2186,
            "subtopicName": "Work energy theorem and its applications"
          }
        ],
        "subjects": [
          {
            "subjectId": 3,
            "subject": "Mathematics"
          }
        ]
      },
      {
        "cardType": 'videos',
        "mappingId": 143,
        "videoId": 987,
        "title": "Work energy theorem and its applications.mp4",
        "thumbnailURL": "https://s3-alpha-sig.figma.com/img/054d/ff60/c4b1f9e3041360ef7c55eeff7ce653a0?Expires=1683504000&Signature=g~gJtQYzhy-rwmMUt0SMK-C3D55aYzkuhz-OROOVE82LQ5oa4EdH9Prtv9gCfOu9o3Y5geDm6hUmaxNdWeEHwTSOkAafMMWg41q0CLWlNj1gE3~Rh8NVvQmCsfyXcHlIfBSDEvd37fS~q2Qst65VFRwU9qKoDBGQ~ftTQT0S2in4Pc1WUgnv6Qe3KqsSgAN1H2UUOT56KW26n37tvMYUjxaE0MASkXKpfMSAZ0~CqomASQnBWgOLK9fF1KLnOPxUco1M7yUsSqU0yGJPlrxvpaiSmj8Ty-fYZGY6NkfwqqBnBSAXGUy2E4EoKdP95VjrmKfPYFwfb4ex6NKVj6-GlA__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4",
        "videoURL": "",
        "videoTypeId": 1,
        "videoType": "Conceptual",
        "orderId": 0,
        "duration": "147",
        "description": "",
        "subtopics": [
          {
            "subtopicId": 2186,
            "subtopicName": "Work energy theorem and its applications"
          }
        ],
        "subjects": [
          {
            "subjectId": 1,
            "subject": "Physics"
          }
        ]
      },
      {
        "cardType": 'Topic_summary',
        "subjectId": 2,
        "topicId": 1515,
        "topicName": "Equilibrium of system of charges system of charges",
        "subtopicsCount": 1,
        "publishedFlashcardCount": 3,
        "publishedVideoCount": 5,
        "flashcardTaggedQuestionsCount": 3,
        "subjects": [
          {
            "subjectId": 3,
            "subject": "Mathematics"
          }
        ]
      },
      {
        "cardType": 'memory_cards',
        "videoId": 987,
        "title": "The state of heart when it is not pumping blood effect...",
        "videoURL": "",
        "videoTypeId": 1,
        "videoType": "Conceptual",
        "orderId": 0,
        "duration": "147",
        "description": "",
        "subtopics": [
          {
            "subtopicId": 2186,
            "subtopicName": "Work energy theorem and its applications"
          }
        ],
        "subjects": [
          {
            "subjectId": 4,
            "subject": "Botany"
          }
        ]
      },
    ]

  popSubjects:any = [];
  popSubjectSelected:any = [];


  allTopicsSummeryProgress:any =[]
  noOfViews: number;
  userId:any;
  userInfo:any;
  subjectNameList:any;
  selectedSubjectName:any;
  selectedSubjects:any;
  currentScrollPosition:any =0;
  pageNum:any = 0;
  pageLimit:any = 10;

  constructor(public dialog: MatDialog,public selfLearnService: SelfLearnService,
    public router: Router, public spinner:NgxSpinnerService,private scroller: ViewportScroller) { }

  ngOnInit(): void {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.userId = this.userInfo.userDto.userId;
    this.noOfViews = this.getNoOfViews();
    this.allBookMarksList  =[];
    this.getSubjects();
    this.getAllBookMarkAssets();
  }


  displayTime(duration:any){
    return this.selfLearnService.secondsToTime(duration);
  }

  getNoOfViews(){
    return this.selfLearnService.generateRandomNumber();
  }

  displayImage(url:any){
    return url?.replaceAll('https', 'http');
  }

  openBookmarkSubjectDialog() {
    const dialogRef= this.dialog.open(BookmarksSubjectDialogComponent, { 
      width:'585px', 
      panelClass: 'bookmark-subject-modal',
      data: {
        dialogSection: this.popSubjects,
        selectedSubjects: this.popSubjectSelected
      }
     });
     dialogRef.afterClosed().subscribe((value) => {
     
      this.popSubjectSelected = [];
  
      value?.map((sub:any) => {
        this.popSubjectSelected.push(sub)
      });
      this.popSubjectSelected = [...new Set(this.popSubjectSelected)]
      this.selectedSubjects
      this.selectedSubjectName = this.subjectNameList.find((item1:any)=> item1.nodeId == this.popSubjectSelected[0]);
      this.pageNum =0;
      this.allBookMarksList  =[];
      this.currentScrollPosition =0;
      this.getAllBookMarkAssets();
     });
  }
  getAllBookMarkAssets(){
    this.spinner.show();   
    this.selfLearnService.getAllBookMarkedAssets(this.selectedFilterValues,this.popSubjectSelected,this.pageNum,this.pageLimit).subscribe((res:any) => {
      this.spinner.hide();
      res.data.map((item:any) => {
        this.allBookMarksList.push(item)
      })
    })
  }
  changeFilter(event:any,type:any){
     console.log(event.target.checked);
     if(event.target.checked == true){
      this.selectedFilterValues.push(type);
     }else if(event.target.checked == false){
      this.selectedFilterValues = this.selectedFilterValues.filter((item:any) => item != type)
     }
     this.pageNum =0;
     this.allBookMarksList  =[];
     this.currentScrollPosition =0;
     this.getAllBookMarkAssets();
  }
  getSubjects(){


    this.selfLearnService.getSubjectsForExam(this.userId , this.selfLearnService.getCmsExamID()).subscribe((resp) => {
      if (resp?.data?.childNodes != undefined) { 
        
        this.subjectNameList = resp?.data?.childNodes.filter((subject:any) => subject.isChaptersAvailable == true);
        this.popSubjects =  this.subjectNameList;
    
      }});
  }
  @HostListener('window:scroll', ['$event'])
  onScroll(e:any) {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
     if(this.currentScrollPosition==0 || scrollPosition >= (this.currentScrollPosition+500)){
      this.currentScrollPosition = scrollPosition;
      if( this.pageNum ==0){
        this.pageNum =   this.pageNum+11
      }else{
        this.pageNum =   this.pageNum+10
      }
  
      this.getAllBookMarkAssets();
     }
    // Perform actions based on the scroll position
 
  }

  divScroll(e:any) {
    console.log('div App', e);
  }
  navigateToMylibrary(){
    this.router.navigate([`selfLearn-V2/my-library`]);
  }
}
